import { useCallback } from 'react'
import { useActivitiesContext } from '../../../../context'
import { openDetailsActionCreator } from '../../../../state'

type Props = {
  id: number
}

export function useHandlers(props: Props) {
  const { id } = props
  const [, dispatch] = useActivitiesContext()
  const handleShowActivity = useCallback(() => {
    dispatch(openDetailsActionCreator({ component: 'details', id }))
  }, [dispatch, id])

  return {
    handleShowActivity,
  }
}
